import { onError } from '@apollo/client/link/error';
import { ErrorHandlerService } from './services/error-handler/error-handler.service';
import { NgModule } from '@angular/core';
import { ApolloClientOptions, ApolloLink, InMemoryCache } from '@apollo/client';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { environment } from '../environments/environment';


export function createApollo(
  httpLink: HttpLink,
  errorHandler: ErrorHandlerService  
): ApolloClientOptions<any> {
  const uri = environment.apiUrl + '/graphql';

  const http = httpLink.create(
    { uri, withCredentials: true });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    errorHandler.handleGraphQLError(graphQLErrors ?? [], networkError);
  });

  return {
    link: ApolloLink.from([errorLink, http]),
    cache: new InMemoryCache(),
  };
}

@NgModule({
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink, ErrorHandlerService], // ← add dep
    },
  ],
})
export class GraphQLModule {}